/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useState } from "react";

// react-router-dom components
import { Link, useNavigate } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
// import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Images
// import bgImage2 from "assets/safety/45001-2-scaled.webp";
import bgImage2 from 'assets/safety/gemini-3-pro-image.webp'
import CoverLayout from "../components/CoverLayout";
import { loginForm } from "constants/forms/loginForm";
import { Input } from "antd";
import MaskPassword from "components/fields/password/Password";
import { GeneralFetch } from "Api/generalFetch/generalFetch";
import { CircularProgress } from "@mui/material";
import { updatePasswordForm } from "constants/forms/loginForm";
import { passwordRequest } from "constants/forms/loginForm";
import LoginIcon from '@mui/icons-material/Login';
import { userData } from "schemas";
import { useSetRecoilState } from "recoil";
import { useParams } from "hooks/common/useQueryParams";
import { broadcastData } from "hooks/common/broadCast";
import { locais } from "schemas";
import { getLayoutByDevice } from "hooks/mobileCheck/useCheckMobile";

function Basic() {
  const isMobile = getLayoutByDevice();
  const [formData, setFormData] = useState({});
  const { fetchData, data, loading } = GeneralFetch()
  const navigate = useNavigate()
  const [update, setUpdate] = useState(false)
  const [notMatch, setMatch] = useState(true)
  const [recover, setRecover] = useState(false)
  const disabled = loading || (update && !notMatch)
  const setUserData = useSetRecoilState(userData)
  const { urlParamiters } = useParams()
  const { id } = urlParamiters()
  const setLocais = useSetRecoilState(locais)

  const onChange = (fieldId, value) => setFormData(prev => ({ ...prev, [fieldId]: value }))

  useEffect(() => {
    if (update)
      if (formData.password != null && formData.passwordConfirmation != null)
        setMatch(formData.password == formData.passwordConfirmation)
  }, [formData])

  function btnEvent(endPoint) {
    void fetchData(formData, endPoint, 'post', 'login')
  }

  const fields = (props) => {
    switch (props.type) {
      case "email": return <Input
        onKeyUp={(e) => {
          if (e.key === "Enter" && formData.email && formData.password) {
            btnEvent(update ? "passwordUpdate" : recover ? "passwordRequest" : "login")
          }
        }}
        placeholder={props?.placeholder}
        value={formData[props.fieldId] || ""}
        onChange={(e) => onChange(props.fieldId, e.target.value)}
      />
      case "password": return <MaskPassword
        onKeyUp={(e) => {
          if (e.key === 'Enter' && formData.email && formData.password) {
            btnEvent(update ? "passwordUpdate" : recover ? "passwordRequest" : "login")
          }
        }}
        {...props}
        formData={formData}
        onChange={onChange}
      />
    }
  }

  useEffect(() => {
    if (data?.token) {
      sessionStorage.setItem("token", data?.access_token)
      if (data?.user?.ja_acedeu == 0) {
        setUpdate(true)
        setFormData({})
        setFormData({ user_id: data?.user?.id })
      } else {
        setUserData({ id: data?.user?.id, acesso: JSON.parse(data?.user?.acesso) })
        sessionStorage.setItem("token", data?.token)
        sessionStorage.setItem("uId", data?.user?.id)
        sessionStorage.setItem("acesso", JSON.parse(data?.user?.acesso))
        sessionStorage.setItem("email", data?.user?.email)
        sessionStorage.setItem("nome", data?.user?.name?.split(" ")[0])
        sessionStorage.setItem("apelido", data?.user?.name?.split(" ")[1])
        sessionStorage.setItem('receiveAllNotifications', data?.user?.receiveAllNotifications)
        broadcastData('token', data?.token)

        fetchData('', 'locais', 'get', 'locais').then((resp) => {
          setLocais(resp?.locais?.map(x => { return { value: x.id, label: x.local } }))
        })

        if (isMobile) navigate('/mobile-home')
        else if (id != null) navigate('/registos?id=' + id)
        else navigate("/dashboard")
      }
    } else {
      setUpdate(false)
      setRecover(false)
      setFormData({})
    }
  }, [data])

  console.log(isMobile,'iss')
  return (
    <CoverLayout coverHeight={'50vh'} image={bgImage2}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            {update ? "Actualizar Senha" : recover ? "Recuperar Senha" : "Iniciar sessão"}
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form">
            {
              (update ? updatePasswordForm : recover ? passwordRequest : loginForm)().map((field) => {
                return (
                  < MDBox mb={2} >
                    {fields(field)}
                  </MDBox>
                )
              })
            }
            {(update && !notMatch) && <span style={{ margin: "-10px 0 -10px 0", fontSize: "13px", fontWeight: "bold", color: "#F26157" }} >!! As senhas introduzidas são diferentes !!</span>}
            <MDBox mt={update ? 2 : 4} mb={1}>
              <div style={disabled ? { cursor: "not-allowed" } : {}} >
                <MDButton onClick={() => btnEvent(update ? "passwordUpdate" : recover ? "passwordRequest" : "login")} disabled={disabled} variant="gradient" color="info" fullWidth>
                 
                 {isMobile }
                  {
                    loading ?
                      <CircularProgress size={"25px"} style={{ color: "#fff" }} />
                      : update ? "Actualizar" : recover ? "Recuperar" : 'entrar'
                  }
                </MDButton>
              </div>
            </MDBox>
            <MDBox mt={3} mb={1} textAlign="center">
              {(!update && !recover) && <MDTypography variant="button" color="text">
                Esqueceu senha?{" "}
                <MDTypography
                  variant="button"
                  color="info"
                  fontWeight="medium"
                  textGradient
                  onClick={() => { setFormData({}); setRecover(true) }}
                  style={{ cursor: "pointer" }}
                >
                  Recuperar
                </MDTypography>
              </MDTypography>}
            </MDBox>
            {recover && <MDBox mt={3} mb={1} textAlign="left" style={{ cursor: "pointer", width: "50%" }} onClick={() => { setFormData({}); setRecover(false) }} >
              <LoginIcon />
              <MDTypography
                variant="button"
                color="info"
                fontWeight="medium"
                textGradient
                ml={1}
              >
                Iniciar Sessão
              </MDTypography>
            </MDBox>}
          </MDBox>
        </MDBox>
      </Card>
    </CoverLayout >
  );
}

export default Basic;
